import * as Route from '../utils/serverRoutes';
import {
  transformResponseCollection,
  updateCollectionById,
  payloadToData,
} from '../utils/helpers';
import makeRequest from '../utils/makeRequest';

const keyResource = {
  state: {
    collection: [],
    uploading: false,
  },
  reducers: {
    fetchKeyResourcesReducer(state, { collection }) {
      return { ...state, collection };
    },
    addKeyResourceReducer(state, payload) {
      return { ...state, collection: [...state.collection, payload] };
    },
    updateKeyResourceReducer(state, payload) {
      return {
        ...state,
        collection: updateCollectionById(state.collection, payload.id, payload),
      };
    },
    removeKeyResourceReducer(state, { id }) {
      const collection = state.collection.filter((e) => e.id !== id);

      return { ...state, collection };
    },
    updateAttributeReducer(state, payload) {
      return { ...state, ...payload };
    },
  },
  effects: (dispatch) => ({
    async fetchKeyResources(bmcId) {
      dispatch.keyResource.updateAttributeReducer({ uploading: true });

      makeRequest({
        dispatch,
        url: Route.keyResources(bmcId),
        success: (response) => {
          dispatch.keyResource.fetchKeyResourcesReducer({
            collection: transformResponseCollection(response.data.data),
          });
        },
        finish: () => {
          dispatch.keyResource.updateAttributeReducer({ uploading: false });
        },
      });
    },
    async addKeyResource(_, state) {
      makeRequest({
        dispatch,
        method: 'post',
        url: Route.keyResources(state.bmc.current.id),
      });
    },
    async updateKeyResource(payload, state) {
      const data = payloadToData(payload);
      dispatch.keyResource.updateKeyResourceReducer(data);

      makeRequest({
        dispatch,
        method: 'put',
        url: Route.keyResource(state.bmc.current.id, payload.id),
        data: { keyThing: data },
      });
    },
    async removeKeyResource(payload, state) {
      makeRequest({
        dispatch,
        method: 'delete',
        url: Route.keyResource(state.bmc.current.id, payload.id),
      });
    },
  }),
};

export default keyResource;
